import Cookies from "universal-cookie";

export class MiscFns {
  static moveSecretToCookie() {
    const cookies = new Cookies();
    const clientSecret = localStorage.getItem("clientSecret");
    cookies.set("dataKey", clientSecret, { path: "/" });
  }
}
